import React from 'react';
import { DemeterChartSeriesModel } from '../../../../Generated/Raven-Demeter';
import useSearchParameters from '../../../Components/Navigation/Hooks/useSearchParametersHook';
import useLanguage from '../../../Services/Language/useLanguageHook';
// eslint-disable-next-line max-len
import MarketFactorMathOperationDropdown from '../../Administration/MarketIndicatorsManagement/MarketIndicatorFactor/MarketIndicatorsFactorFields/Common/MarketFactorMathOperationDropdown';
import styles from '../ChartBuilder.module.scss';
import { ChartBuilderRequest } from '../ChartBuilderDefinitions';

interface IChartBuilderDataSourceOptionsProps {
    chartBuilderUpsertRequest: ChartBuilderRequest;
    setChartBuilderUpsertRequest: (chartBuilderUpsertRequest: ChartBuilderRequest) => void;
}

const ChartBuilderMathOperationOptions: React.FC<IChartBuilderDataSourceOptionsProps> = (props: IChartBuilderDataSourceOptionsProps) => {
    // Application and display hooks.
    const [translations] = useLanguage();
    const [searchParameters] = useSearchParameters();
    const dataSeriesIndex = +(searchParameters.dataSeriesTab?.replace('dataSeries', '') || 0);

    const handleRequest = (updatedRequest: DemeterChartSeriesModel) => {
        props.setChartBuilderUpsertRequest({
            ...props.chartBuilderUpsertRequest,
            rows: props.chartBuilderUpsertRequest.rows.map((x, index) => {
                if (dataSeriesIndex === index) {
                    return { ...x, dataCombinationType: updatedRequest.dataCombinationType };
                }

                return x;
            }),
        });
    };

    return (
        <div className={styles.chart_builder_line_break}>
            <p>{translations.chartBuilder.text.combineDataSources}</p>

            <div className={styles.chart_builder_row}>
                <div className={styles.chart_builder_dropdown}>
                    <MarketFactorMathOperationDropdown
                        upsertRequest={props.chartBuilderUpsertRequest!.rows[dataSeriesIndex]}
                        setUpsertRequest={handleRequest}
                    />
                </div>
            </div>
        </div>
    );
};

export default ChartBuilderMathOperationOptions;
